import React, { useEffect } from "react";
import { useState } from "react";
import { getUserInfo } from "../../../services/profile";

export default function Info() {
  const [dataUser, setDataUser] = useState([]);
  const [birth, setBirth] = useState("");

  useEffect(() => {
    function fetchData() {
      getUserInfo().then((res) => {
        if (res.status == 200) {
          let data = res.data.data;
          if (data) {
            setDataUser(data);
            setBirth(data.birth_date);
          }
        }
      });
    }
    fetchData();
  }, []);

  return (
    <div className="sfsfsfeall">
      <div className="pt-2">
        <div className="iteminfo2022">
          <div className="namefdgf w-50">
            <img
              src={"/images/svg/account-info-user-name.svg"}
              alt={""}
              className="image-for-primary-info"
            />
            نام
          </div>

          <div className="dategjas w-50 text-start">{dataUser.first_name}</div>
        </div>

        <div className="iteminfo2022">
          <div className="namefdgf w-50">
            <img
              src={"/images/svg/account-info-user-name.svg"}
              alt={""}
              className="image-for-primary-info"
            />
            نام خانوادگی
          </div>

          <div className="dategjas w-50 text-start ">{dataUser.last_name}</div>
        </div>

        <div className="iteminfo2022">
          <div className="namefdgf w-50">
            <img
              src={"/images/svg/account-info-user-phone.svg"}
              alt={""}
              className="image-for-primary-info-small"
            />
            موبایل
          </div>

          <div className="dategjas w-50 text-start ">
            {dataUser.mobile_number}
          </div>
        </div>
      </div>
    </div>
  );
}
